import React from 'react';
export function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const scrollToContact = () => scrollToSection('contact');
  return <footer className="bg-black border-t border-gray-900 pt-12 md:pt-16 pb-6 md:pb-8" data-id="element-149">
      <div className="container mx-auto px-4" data-id="element-150">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-10 md:mb-12" data-id="element-151">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1" data-id="element-152">
            <a href="#" className="block mb-4" onClick={e => {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          }} data-id="element-153">
              <img src="https://cdn.magicpatterns.com/uploads/4knKGYKp4b1RKdWAFRKcPp/Strattigize-removebg-preview.png" alt="Strattigize Logo" className="h-16 md:h-24 w-auto brightness-0 invert" data-id="element-154" />
            </a>
            <p className="text-gray-500 text-xs md:text-sm leading-relaxed mb-4 md:mb-6" data-id="element-155">
              Save Time & Make Money. We automate your business so you can focus
              on growth.
            </p>
            <div className="flex items-center gap-3" data-id="element-156">
              {/* Instagram */}
              <a href="https://www.instagram.com/strattigizenow/" target="_blank" rel="noopener noreferrer" className="group w-9 h-9 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center transition-all duration-300 hover:bg-gradient-to-br hover:from-[#f9ce34] hover:via-[#ee2a7b] hover:to-[#6228d7] hover:border-transparent hover:scale-110 hover:shadow-lg hover:shadow-pink-500/20" aria-label="Instagram" data-id="element-157">
                <svg viewBox="0 0 24 24" fill="currentColor" className="w-[18px] h-[18px] text-gray-400 group-hover:text-white transition-colors duration-300" data-id="element-158">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" data-id="element-159" />
                </svg>
              </a>

              {/* LinkedIn */}
              <a href="https://www.linkedin.com/in/strattigize-with-dan-4082473a7" target="_blank" rel="noopener noreferrer" className="group w-9 h-9 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center transition-all duration-300 hover:bg-[#0A66C2] hover:border-transparent hover:scale-110 hover:shadow-lg hover:shadow-blue-500/20" aria-label="LinkedIn" data-id="element-160">
                <svg viewBox="0 0 24 24" fill="currentColor" className="w-[18px] h-[18px] text-gray-400 group-hover:text-white transition-colors duration-300" data-id="element-161">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" data-id="element-162" />
                </svg>
              </a>

              {/* Facebook - hidden for now, link stored: https://www.facebook.com/share/1MkLkiUEMk/ */}
            </div>
          </div>

          {/* Solutions */}
          <div data-id="element-163">
            <h4 className="text-white font-bold mb-4 md:mb-6 text-sm md:text-base" data-id="element-164">
              Solutions
            </h4>
            <ul className="space-y-2 md:space-y-3 text-xs md:text-sm text-gray-500" data-id="element-165">
              {[{
              name: 'Starter Plan',
              id: 'pricing'
            }, {
              name: 'Unlimited Plan',
              id: 'pricing'
            }, {
              name: 'Pro Plan',
              id: 'pricing'
            }, {
              name: 'Custom Solutions',
              id: 'contact'
            }, {
              name: 'Free Consultation',
              id: 'contact'
            }].map(item => <li key={item.name} data-id="element-166">
                  <button onClick={() => scrollToSection(item.id)} className="hover:text-primary transition-colors duration-300 text-left" data-id="element-167">
                    {item.name}
                  </button>
                </li>)}
            </ul>
          </div>

          {/* Company */}
          <div data-id="element-168">
            <h4 className="text-white font-bold mb-4 md:mb-6 text-sm md:text-base" data-id="element-169">
              Company
            </h4>
            <ul className="space-y-2 md:space-y-3 text-xs md:text-sm text-gray-500" data-id="element-170">
              {[{
              name: 'How It Works',
              id: 'how-it-works'
            }, {
              name: 'Pricing',
              id: 'pricing'
            }, {
              name: 'Case Studies',
              id: 'results'
            }, {
              name: 'FAQ',
              id: 'faq'
            }, {
              name: 'Contact',
              id: 'contact'
            }].map(item => <li key={item.name} data-id="element-171">
                  <button onClick={() => scrollToSection(item.id)} className="hover:text-primary transition-colors duration-300 text-left" data-id="element-172">
                    {item.name}
                  </button>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div className="col-span-2 md:col-span-1" data-id="element-173">
            <h4 className="text-white font-bold mb-4 md:mb-6 text-sm md:text-base" data-id="element-174">
              Contact
            </h4>
            <ul className="space-y-2 md:space-y-3 text-xs md:text-sm text-gray-500 mb-4 md:mb-6" data-id="element-175">
              <li data-id="element-176">
                <a href="tel:+447366433459" className="hover:text-primary transition-colors duration-300" data-id="element-177">
                  +44 7366 433459
                </a>
              </li>
              <li data-id="element-178">
                <a href="mailto:strattigize@gmail.com" className="hover:text-primary transition-colors duration-300" data-id="element-179">
                  strattigize@gmail.com
                </a>
              </li>
            </ul>
            <button onClick={scrollToContact} className="bg-primary/10 text-primary border border-primary/30 px-4 py-2 rounded font-bold text-xs md:text-sm hover:bg-primary hover:text-white transition-colors duration-300" data-id="element-180">
              GET STARTED
            </button>
          </div>
        </div>

        <div className="border-t border-gray-900 pt-6 md:pt-8 flex flex-col md:flex-row justify-between items-center text-[10px] md:text-xs text-gray-600 gap-3 md:gap-0" data-id="element-181">
          <p data-id="element-182">© 2026 Strattigize. All rights reserved.</p>
          <div className="flex space-x-4 md:space-x-6" data-id="element-183">
            <a href="#terms" className="hover:text-gray-400 transition-colors duration-300" data-id="element-184">
              Terms &amp; Conditions
            </a>
            <a href="#refund-policy" className="hover:text-gray-400 transition-colors duration-300" data-id="element-185">
              Refunds &amp; Cancellation
            </a>
          </div>
        </div>
      </div>
    </footer>;
}